import { Skeleton, Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"

interface IMobileListApplicationSkeletonProps {
    removeIcon?: boolean
}

/** Loading skeleton for mobile application list view */
const MobileListApplicationSkeleton = ({
    removeIcon,
}: IMobileListApplicationSkeletonProps): ReactElement => (
    <Stack
        direction="row"
        width="100%"
        paddingLeft={GRID_SPACING}
        marginBottom={GRID_SPACING}
        spacing={2}
    >
        {!removeIcon && <Skeleton variant="circular" width={50} height={50} />}
        <Stack>
            <AppSkeleton
                width={removeIcon ? "300px" : "150px"}
                variant="text"
            />
            <AppSkeleton
                width={removeIcon ? "250px" : "200px"}
                variant="text"
            />
        </Stack>
    </Stack>
)

MobileListApplicationSkeleton.defaultProps = {
    removeIcon: false,
}

export default MobileListApplicationSkeleton
